export const URLS_REFRESH = ['Associate/refresh'];
